import { render } from "./OutliersAnalysis.vue?vue&type=template&id=51f4d207"
import script from "./OutliersAnalysis.vue?vue&type=script&lang=js"
export * from "./OutliersAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__